import Login from "./pages/auth/login/Login";
import Register from "./pages/auth/register/Register";
import Home from "./pages/home/Home";
import AdminDashboard from "./pages/AdminDashboard/AdminDashboard";
import AdminRoute from "./pages/AdminRoute"; 
import UserStatus from "./pages/user/User"; 

import { AuthProvider } from "./contexts/authContext";
import { Routes, Route } from "react-router-dom";
import ForgotPassword from "./pages/auth/login/ForgotPassword";

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="*" element={<Login />} />
        <Route path="/home" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/register" element={<Register />} />
        <Route
          path="/admin"
          element={
            <AdminRoute>
              <AdminDashboard />
            </AdminRoute>
          }
        />
        <Route
          path="/user/:orderId"
          element={
            <AdminRoute>
              <UserStatus />
            </AdminRoute>
          }
        /> 
      </Routes>
    </AuthProvider>
  );
}

export default App;
